import "./Account.css";
import { useActionState, useContext, useEffect, useOptimistic, useState, } from "react";
// import Button from "@mui/material/Button";
// import { AppRegistration, Login, Logout, Refresh } from "@mui/icons-material";
// Dialog関連
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, } from '@mui/material';
import { Box, Grid, Paper, TextField, Checkbox, LinearProgress, CircularProgress, Pagination, Stack } from '@mui/material';

import AppContext from "../contexts/AppContext";
import CookieContext from "../contexts/CookieContext";
import ExpTimeContext from "../contexts/ExpTimeContext";
import axios from "axios";
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";

const UuidButton = styled.button`
  width: 400px;
  color: ${"lightgray"};
  background: ${({ disabled }) =>
    disabled
      ? "linear-gradient(180deg, #666666, #999999)"
      : "linear-gradient(180deg, #100c08,rgb(4, 114, 46))"};
  ${({ disabled }) =>
    disabled
      ? `text-shadow:rgb(0, 0, 0) 5px 5px 10px; box-shadow:rgb(128, 128, 128) 5px 5px 10px;`
      : `text-shadow: #cccccc 5px 5px 10px; box-shadow: #cccccc 5px 5px 10px;`};
`;

const MyPage = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm({ mode: "onChange" });

  const { apiHost, error, setError, AppButton } = useContext(AppContext);
  const basePath = 'mypage/';

  // const { cookies, setCookie, setJwtCookies, refreshJwtCookies, removeJwtCookies, setWachaBizCookies } =
  //   useContext(CookieContext);
  const { cookies, setJwtCookies, refreshJwtCookies, removeJwtCookies } =
    useContext(CookieContext);
  const setWachaBizCookies = (abc) => {
    // alert(abc)
  }

  const [axiosErr, setAxiosErr] = useState({ code: "", msg: "" });
  const { leftTime, leftTimeMs, leftTimeDhms } = useContext(ExpTimeContext);

  // ボタンの有効化/無効化の管理
  const [disabled, setDisabled] = useState(false);

  // ログインタイプを設定
  const [loginType, setLoginType] = useState(1);
  const [uuid, setUuid] = useState();
  const [managementCd, setManagementCd] = useState();

  // const [listUuid, setListUuid] = useState();

  // const [transactionFinishedDialogOpen, setTransactionFinishedDialogOpen] = useState(false);
  // const handleTransactionFinishedDialogClose = () => {
  //   setTransactionFinishedDialogOpen(false);
  // }



  // uuidListsの管理
  let myLists = new Array([cookies.uuidLists]);  















// ここで値設定エラーになる


  if (cookies.uuidLists) {
    // alert(cookies.uuidLists)
    // setMyLists(cookies.uuidLists);
    // setMyLists((prevMyLists) => [...prevMyLists, cookies.uuidLists]);
    // setMyLists((prevMyLists) => [...prevMyLists, '2222222222']);
  }
  // const [uuidLists, setUuidLists] = useState(JSON.loads('{"name": "deviceUuid", "age": 26, "uuidLists": ["11111", "22222"]}'));

  // alert(uuidLists["name"])
  // alert(uuidLists["uuidLists"])

  const addUuidLists = () => {
    // setUuidLists((prevUuidLists) => [...prevUuidLists, '2222222222']);
  };


  // const onDeviceRegister = async (data) => {
  const onRegister = async (data) => {

    // ボタンを無効化
    setDisabled(true);
    try {
      const res = await axios
        .post(
          // `https://api2.wacha.biz/device/register/`,
          `${apiHost}device/register/`,
          {
            // device_uuid: data.device_uuid,
            // password: data.password,
            // password: 'dummy',
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        )

        // 作成したuuidとmanagement_cdでログイン
      onLogin(res.data.uuid, res.data.management_cd);

    } catch (e) {
    } finally {
    }
  }

  const onLoginBase = async (data) => {
    if(loginType===1){
      data.uuid = data.uuid
      data.management_cd = data.management_cd
    }
    else if(loginType===2){
      data.uuid = data.auto_uuid
      data.management_cd = data.auto_management_cd
    }

    // ボタンを無効化
    setDisabled(true);
    await axios
      .post(
        // `https://api2.wacha.biz/device/token/`,
        `${apiHost}device/token/`,
        {
          uuid: data.uuid,
          password: data.management_cd,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((res) => {
        setDisabled(false);
        setJwtCookies(res.data.access, res.data.refresh);
      })
      // .then(() => {
      //   // ログイン後はMyPageへ遷移
      //   (window.location.href = "/");
      // })
      .catch((err) => {
        setDisabled(false);
        if (err.response) {
          // client received an error response (5xx, 4xx)
          console.log("err.response:", err.response);
          console.log("err.response.status:", err.response.status);
          console.log("err.response.data.detail:", err.response.data.detail);

          setAxiosErr({
            ...axiosErr,
            code: err.response.status,
            msg: "ユーザ名またはパスワードが違います",
          });
        } else if (err.request) {
          // client never received a response, or request never left
          console.log("err.request:", err.request);

          setAxiosErr({
            ...axiosErr,
            code: "",
            msg: "エラーが発生しました",
          });
        } else {
          // anything else
          console.log("err:", err);

          setAxiosErr({
            ...axiosErr,
            code: "",
            msg: "エラーが発生しました",
          });
        }
      });
  };

  const onLogin = async (data) => {
    setLoginType(prevValue => 1);
    onLoginBase(data);
  };

  const onAutoLogin = async (data) => {
    setLoginType(prevValue => 2);
    data.uuid = data.auto_uuid
    data.management_cd = data.auto_management_cd
    onLoginBase(data);
  };

  const onUrlCopy = async (data) => {
    setLoginType(prevValue => 1);
    onLoginBase(data);
  };

  const onClearUuid = async () => {
    removeJwtCookies();
    // ログアウト後はHomeへ遷移
    (window.location.href = "/");
  }


  // jwtAccessの有無によって表示内容を変更
  const returnIfJwtAccessOrNot = () => {
    if (cookies.jwtAccess) {
      return (
        <>
          <div>
            jwtAccess:{cookies.jwtAccess}<br />
            jwtRefresh:{cookies.jwtRefresh}<br />
          </div>
          <div style={{ margin: "5px", fontWeight: 700, }}>

            <form onSubmit={handleSubmit(onLogin)}>
              <input style={{ margin: "5px", fontSize: 30, }} {...register('uuid')} /><br />
              <input style={{ margin: "5px", fontSize: 30, }} {...register('management_cd')} />
              <UuidButton disabled={disabled}>
                ログイン（uuid/management_cd指定）<br />
              </UuidButton>
            </form>

            <form onSubmit={handleSubmit(onAutoLogin)}>
              <input type="hidden" name="auto_uuid" value={cookies.accessTokenUuid} {...register('auto_uuid')} />
              <input type="hidden" name="auto_management_cd" value={cookies.accessTokenManagementCd} {...register('auto_management_cd')} />
              <UuidButton disabled={disabled}>
                自動ログイン（uuid/management_cd自動）<br />
                uuid:{cookies.accessTokenUuid}<br />
              </UuidButton>
            </form>

            <form onSubmit={handleSubmit(onUrlCopy)}>
              <input type="hidden" name="auto_uuid" value={cookies.accessTokenUuid} {...register('auto_uuid')} />
              <input type="hidden" name="auto_management_cd" value={cookies.accessTokenManagementCd} {...register('auto_management_cd')} />
              <UuidButton disabled={disabled}>
                自動ログインUrlコピー（uuid/management_cd）<br />
                uuid:{cookies.accessTokenUuid}<br />
              </UuidButton>
            </form>


           </div>
        </>
      )
    }
    else {
      return (
        <>
          <div style={{ margin: "5px", fontWeight: 700, }}>
            <form onSubmit={handleSubmit(onLogin)}>
              {/* <input type="text" {...register('uuid', {required: '必須'})} /> */}
              {/* <input type="text" name="uuid" value='aaaa' /> */}
              <AppButton>
                <span>AAA</span>
              </AppButton>
            </form>
          </div>
        </>
      )
    }
  }

  const [updatedPost, submitActionPost, isPendingPost] = useActionState(
    async (previousPost, formData) => {
      const name = formData.get('name');

      const optimistic = {
        list_uuid: '9876543210',
        name: name + '（更新中）',
        // room_uuid: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
      };

      // 楽観的更新情報を表示
      updateOptimisticPost(optimistic);

      // 入力欄をクリアしてフォーカスを当てる 
      document.getElementById('name').value = "";
      document.getElementById('name')?.focus();
  
      try {
        if (cookies.jwtAccess) {
          // jwtがある場合、headers（認証情報）有り
          const headers = {
            'Content-Type': 'application/json',
            'Authorization': `JWT ${cookies.jwtAccess}`,
          }

          const response = await axios.post(`${apiHost}${basePath}`, 
              {
              name: formData.get('name'),
            },
            {headers},
          )

          if (response.status === 201) {
            // setTransactionFinishedDialogOpen(true);
            // 更新した名前を返す
            return response.data
          } else if (response.status === 401) {
            setError('ログインしてください');
          } else {
            setError('エラー');
          }
        } else {
          setError('認証エラー');
        }
      } catch (err) {
        // handleMessageBoxOpen('タイトル', 'メッセージ')
        // console.log(err);
        // setError('通信エラー');
        return previousPost;
      } finally {
      }
    }, ""
  );

  const [optimisticPost, updateOptimisticPost] = useOptimistic(updatedPost);




  return (
    <>
      {returnIfJwtAccessOrNot()}
      {/* <div style={{ margin: "5px", fontWeight: 700, }}>
        <form onSubmit={handleSubmit(onLogin)}>
          <AppButton disabled={disabled}>
            <span>ログイン</span>
          </AppButton>
        </form>
      </div> */}
      現在登録中のcookie
      <div style={{ margin: "5px", fontWeight: 700, }}>
        cookies.accessTokenUuid:{cookies.accessTokenUuid}<br />
        cookies.accessTokenManagementCd:{cookies.accessTokenManagementCd}<br />
      </div>



      <div className="container">
        <form action={setWachaBizCookies('1234567')}>
        {/* <form action={() => {}}> */}
          <input style={{ margin: "5px", fontSize: 30, }} type="text" id="name" name="name" placeholder="部屋名を入力" />

          {/* ボタン押下の処理中かそうでないかにより、表示内容を変更 */}
          {/* <AppButton type="submit" style={{ margin: "5px", fontSize: 20}} disabled={isPendingPost}> */}
          <AppButton type="submit" style={{ margin: "5px", fontSize: 20}} disabled={isPendingPost}>
            {!isPendingPost && <>部屋を作成</>}
            {isPendingPost && <>処理中...</>}
          </AppButton>

          {/* 処理中の場合、表示 */}
          {isPendingPost && <>
            <CircularProgress variant="indeterminate"
              disableShrink
              enableTrackSlot
              sx={(theme) => ({
                color: '#e42e16',
                animationDuration: '1000ms',
                ...theme.applyStyles('dark', {
                  color: '#308fe8',
                }),
              })}
              size={40}
              thickness={4}
            />
          </>}
        </form>
      </div>

      {/* alert(uuidLists["name"])
      alert(uuidLists["uuidLists"]) */}

      {/* <UuidButton variant="contained">{JSON.parse(
        '{"uuidList01":"00000000000000000000000000000000", "uuidList02":"11111111111111111111111111111111"}'
      )}
      </UuidButton> */}
      {/* <UuidButton variant="contained" color="primary">
        {uuidLists["name"]}
      </UuidButton> */}
      {/* {myLists.push(1111)} */}
      {/* {myLists.push(22)} */}
      <UuidButton variant="contained" color="primary">
      {cookies.uuidLists ? cookies.uuidLists.length : '-'}
      </UuidButton>
      <UuidButton variant="contained" color="primary">
      {cookies.uuidLists ? cookies.uuidLists : '-'}
      </UuidButton>
      <UuidButton variant="contained" color="primary">
      {cookies.uuidLists ? myLists = [...myLists, 'aa33', 'bb44', 'cc55'] : '-'}
      </UuidButton>
      <UuidButton variant="contained" color="primary">
      長さ：{myLists.length}
      </UuidButton>
      <UuidButton variant="contained" color="primary">
      myList[0]：{myLists[0]}
      </UuidButton>
      <UuidButton variant="contained" color="primary">
      myList[1]：{myLists[1]}
      </UuidButton>
      <UuidButton variant="contained" color="primary">
      myList[2]：{myLists[2]}
      </UuidButton>
      <UuidButton variant="contained" color="primary">
      myList[3]：{myLists[3]}
      </UuidButton>
      {/* <UuidButton variant="contained" color="primary">
      {cookies.uuidLists ? len(list(cookies.uuidLists)) : '-'}
      </UuidButton> */}
      {/* <UuidButton variant="contained" color="primary">
        {myLists[0]}
      </UuidButton>
      <UuidButton variant="contained" color="primary">
        {myLists[1]}
      </UuidButton> */}
      <AppButton variant="contained" color="primary">
        Primary
      </AppButton>
      <AppButton variant="contained" color="secondary">
        Secondary
      </AppButton>
      <AppButton variant="contained" disabled>
        Disabled
      </AppButton>

    </>
  )
}
export default MyPage